// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__2hiUF","inputSuccess":"FieldCurrencyInput_inputSuccess__21uVu","inputError":"FieldCurrencyInput_inputError__19yqZ"};